<template>
  <div class="paglierani-widget">
    <div
      v-if="loading"
      class="wg-row"
      style="margin: 10px; justify-content: center"
    >
      <vue-simple-spinner size="medium" line-fg-color="#88ed7c" />
    </div>
    <template v-else>
      <div class="wg-row icons">
        <div 
            v-for="(c,i) in components" 
            :key="'comp-'+i"
            :class="c.id"           
            :title="c.title"
            @click="openDialog(c)">
          <img
            class="com-anm22-app-img-fixed-height-l"
            style="padding:5px;height:100%;"
            :src="$anm22.icons.getWorldIcon(c.icon)"
          />
        </div>
      </div>
      <wg-modal
        :width="windowWidth > 700 ? selectedCustomComponent == 'OperativeDetails' ? '900px' : '700px' : '90%'"
        v-if="showModal"
        @closeModal="closeDialog"
        :portal="true"
      >
        <div slot="header" class="com-anm22-app-text-xl">{{ dialogTitle }}</div>
        <component
          slot="body"
          :is="selectedCustomComponent"
          :projectId="project.idWorldProject"
          :docs="docs"
          @canUpdateProject="setCanUpdate"
          @save="save"
        ></component>
      </wg-modal>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";

export default {
  props: {
    projectId: [Number, String]
  },
  data() {
    return {
      loading: true,
      docs: {},
      showModal: false,
      selectedCustomComponent: "",
      dialogTitle: "",
      canUpdate: false //Boolean semaforo per update progetto
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      windowWidth: state => state.windowWidth
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    customer() {
      if (this.project.customers.length > 0) {
        return this.$store.getters["contacts/get"](this.project.customers[0]);
      } else {
        return null;
      }
    },
    components() {
      return [
        {
          id: 'uploads',
          title: this.$anm22.strLang(this.lang, 'Customer uploads', 'Caricamenti cliente'),
          component: "Uploads",
          icon: "fileDefault"
        },
        {
          id: "quotations",
          title: this.$anm22.strLang(this.lang, "Quotations", "Quotazioni"),
          component: "Quotations",
          icon: "abacus"
        },
        {
          id: "confirmations",
          title: this.$anm22.strLang(
            this.lang,
            "Order confirmations",
            "Conferme ordine"
          ),
          component: "Confirmations",
          icon: "contract"
        },
        {
          id: "details",
          title: this.$anm22.strLang(this.lang, "Order specs", "Commessa"),
          component: "Details",
          icon: "menuTable"
        },
        {
          id: "operativeDetails",
          title: this.$anm22.strLang(this.lang, "Operative details", "Operatività commessa"),
          component: "OperativeDetails",
          icon: "list"
        },
        {
          id: "print",
          title: this.$anm22.strLang(this.lang, "Print", "Stampa"),
          component: "DetailsPrint",
          icon: "printer"
        }
      ];
    }
  },
  methods: {
    async loadData(projectDocs) {
      if (projectDocs) {
        this.docs = projectDocs;
      } else {
        const result = await this.$vlf("paglierani-project-docs").getItem(
          String(this.project.idWorldProject)
        );
        if (result) {
          // Usiamo questo componente come store per i documenti del progetto, non quello centrale
          this.docs = result;
        }
      }
      this.loading = false;
    },
    setCanUpdate(val) {
      this.canUpdate = val;
    },
    async save(docs) {
      const response = await this.$http.post("paglierani", {
        projectId: this.project.idWorldProject,
        docs: docs
      });
      this.$vlf("paglierani-project-docs").setItem(
        String(response.data.docs.project),
        response.data.docs
      );
      await this.loadData();
      if(this.canUpdate) {
        this.updateProject();
      }
    },
    async updateProject() {
      const project = { ...this.project };
      /* ------------------------ PROJECT END DATE UPDATING -------------------------------------------- */
      //Se è presente la Consegna prevista reale viene aggiornata la fine del progetto con la medesima
      //Se è presente la Consegna prevista contrattuale ma non la reale,viene presa questa come fine del progetto
      if (
        this.docs.details
        && this.docs.details.expectedDelivery
        && !this.docs.details.realDelivery
      ) {
        project.endDate = this.docs.details.expectedDelivery;
      } else if (this.docs.details && this.docs.details.realDelivery) {
        project.endDate = this.docs.details.realDelivery;
      }
      const response = await this.$http.post("project/edit", { project }, {
        withCredentials: true
      });
      await this.$store.dispatch("projects/update", {
        vlf: this.$vlf("projects"),
        objs: response.data.projects
      });
      this.canUpdate = false;
    },
    openDialog(obj) {
      this.dialogTitle = obj.title;
      this.selectedCustomComponent = obj.component;
      this.showModal = true;
    },
    closeDialog() {
      this.showModal = false;
      this.loadData();
    }
  },
  async created() {
    this.loadData();
    const response = await this.$http.get(
      "paglierani?projectId=" + this.project.idWorldProject
    );
    this.loadData(response.data.docs);
    await this.$vlf("paglierani-project-docs")
      .setItem(String(response.data.docs.project), response.data.docs)
      .catch(e => console.log(e));
  },
  components: {
    "vue-simple-spinner": Spinner,
    Uploads: () =>
      import(/* webpackChunkName: "custom-965" */ "./Uploads.vue"),
    OperativeDetails: () =>
      import(/* webpackChunkName: "custom-965" */ "./OperativeDetails.vue"),
    Quotations: () =>
      import(/* webpackChunkName: "custom-965" */ "./Quotations.vue"),
    Confirmations: () =>
      import(/* webpackChunkName: "custom-965" */ "./Confirmations.vue"),
    Details: () => import(/* webpackChunkName: "custom-965" */ "./Details.vue"),
    DetailsPrint: () =>
      import(/* webpackChunkName: "custom-965" */ "./DetailsPrint.vue")
  }
};
</script>

<style lang="scss" scoped>
.paglierani-widget .icons {
  align-items: center;
  font-size: 0;
  padding: 5px 0 0 0;
  flex-wrap: nowrap;
}
.paglierani-widget .icons div {
  border-radius: 30px;
  width: 60px;
  height: 60px;
  background-color: #ddd;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  padding: 10px;
  margin: 5px 10px;
  cursor: pointer;

  &:hover {
    background-color: #ccc;
  }
}
</style>

